import { componentType } from '../../hooks/useMixpanel';
import InviteSmsStep from '../../components/OnBoardingWizard/OnBoardingWizardDrawer/StepperWizardContent/Steps/InviteSmsStep';
import styles from './index.module.scss';
import { useParams } from 'react-router';
import { LoadingPlaceholder } from '../../components/LoadingPlaceholder';

const InviteUser = ({ isLoading }: { isLoading: boolean }) => {
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();

  return (
    <LoadingPlaceholder isLoading={isLoading}>
      <div className={styles.root}>
        <InviteSmsStep
          patientUuid={patientUuid}
          btnClassName="hidden"
          mixpanelComponent={componentType.appInvitation}
        />
      </div>
    </LoadingPlaceholder>
  );
};

export default InviteUser;
